import {$, w} from './constants';
const cookies_tl = gsap.timeline();

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    menu_toggle();
});

/* w.on('resize', () =>{
    menu_toggle();
}); */

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    /* C O O K I E S */
    if(localStorage.getItem('hom_cookie')){
        $('#cookies_hom').addClass('hide');
        if( $('#cookies_hom').hasClass('cookies--home')){
            cookies_tl.kill();
        }
    }else{
        $('#cookies_hom').delay(1000).addClass('show');
        if( $('#cookies_hom').hasClass('cookies--home')){
        
            ScrollTrigger.matchMedia({
                // desktop
                "(min-width: 951px)": function() {
                    cookies_tl.to('#cookies_hom', {
                        scrollTrigger : {
                            trigger: '.home-template__hero',
                            scrub: 1,
                            start : "start",
                            end : "bottom+=100",
                            markers : false,
                            onEnter: (self) => {
                                $('#cookies_hom').addClass('active');
                            },
                            onLeaveBack: (self) => {
                                $('#cookies_hom').removeClass('active');
                            },
                        }
                    });
                },
          
                // Tablets & mobile
                "(max-width: 951px)": function() {
                    cookies_tl.to('#cookies_hom', {
                        scrollTrigger : {
                            trigger: '.home-template__hero',
                            scrub: 1,
                            start : "start",
                            end : "bottom+=100",
                            markers : false,
                            onEnter: (self) => {
                                $('#cookies_hom').addClass('active');
                            },
                            onLeaveBack: (self) => {
                                $('#cookies_hom').removeClass('active');
                            },
                        }
                    });
                }
            });
        }
        $('#accept_cookies').click(() => {
            localStorage.setItem('hom_cookie', 'true');
            $('#cookies_hom').addClass('hide');
            $('#cookies_hom').delay(1000).removeClass('show');
            if( $('#cookies_hom').hasClass('cookies--home')){
                cookies_tl.kill();
            }
        })
    }
    /* END: C O O K I E S */

    /* SLIDER S e r v i c e s */
    $('.slide_click').on('click', function(){
        $(this).toggleClass('active');
    });
    const slider = document.querySelector('.slider--grab');
    let isDown = false;
    let startX;
    let scrollLeft;

    if(slider){
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
         // Función para mostrar u ocultar las flechas de la galería
         function toggleGalleryArrows() {
            var gallery = $('.slider--grab');
            var arrows = $('.gallery_arrows');
            var totalWidth = 0;
            gallery.children().each(function() {
                totalWidth += $(this).outerWidth(true); // Incluye márgenes y bordes
            });

            // Verificar si el ancho total de los elementos es mayor que el ancho del contenedor
            if (totalWidth > gallery.width()) {
                arrows.show(); // Mostrar flechas si el ancho total es mayor
            } else {
                arrows.hide(); // Ocultar flechas si el ancho total es igual o menor
            }
        }

        // Llamar a la función al cargar la página y al redimensionar la ventana
        toggleGalleryArrows();

        $(window).resize(function() {
            toggleGalleryArrows();
        });
    }
    /* END SLIDER S e r v i c e s */

    /* POPUP: C o n t a c t */
    $('.trigger_contact_pop > a').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $('#mainContainer').toggleClass('popup_active');
        $('#target_pop_contact').fadeToggle(300).toggleClass('show');
        if( w.width() <= 1030){
            nav.removeClass('aside_open');
        }
    });
    $('#target_pop_contact').on('click', function(e){
        e.stopPropagation();
    });
    $('#mainContainer').on('click', function(e){
        if( $(this).hasClass('popup_active') && $('#target_pop_contact').hasClass('show') ){
            $('#target_pop_contact').fadeOut(300).removeClass('show');
        }
    });

})

const menu_toggle = () =>{
    /* MENÚ: D e s k t o p */
    const menu_tl_home = gsap.timeline();
    const nav = $(".header");
    const logo = $(".header__logo-container");
    const btn_menu = $('#menu_toggle');
    const btn_menu_container = $('.header__toggle');
    if( $('#banner_trigger').length ){
        const banner = $('#banner_trigger');
        menu_tl_home.to(nav, {
            scrollTrigger : {
                trigger: banner,
                scrub: 1,
                start : "start",
                end : "bottom",
                markers : false,
                onEnter: (self) => {
                    nav.addClass('header--transparent');
                    logo.removeClass('active');
                    btn_menu.addClass('home');
                    btn_menu_container.removeClass('active');
                },
                onEnterBack: (self) => {
                    nav.addClass('header--transparent');
                    logo.removeClass('active');
                    btn_menu.addClass('home');
                    btn_menu_container.removeClass('active');
                },
                onLeave: (self) => {
                    nav.removeClass('header--transparent');
                    logo.addClass('active');
                    btn_menu.removeClass('home');
                    btn_menu_container.addClass('active');
                }
            }
        });
    }else{
        $(window).scroll(function (event) {
            if($(this).scrollTop() > nav.height()){
                logo.addClass('active');
                btn_menu_container.addClass('active');
            }else{
                logo.removeClass('active');
                btn_menu_container.removeClass('active');
            }
        });
    }
    // Detect screen width

    if (w.width() > 1030) {
        // Desktop menu
        $('.menu-item-has-children').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Close any other open dropdowns
            $('.menu-item-has-children').not(this).removeClass('active').children('.sub-menu').slideUp(300).removeClass('active');
            
            // Toggle the current dropdown
            $(this).toggleClass('active');
            $(this).children('.sub-menu').slideToggle(300).toggleClass('active');
        });
        
        // Prevent closing when clicking inside the submenu
        $('.menu-item-has-children > .sub-menu').on('click', function(e) {
            e.stopPropagation();
        });
    } else {
        // Mobile menu
        $('.sub-menu--hidden').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Close any other open dropdowns
            $('.sub-menu--hidden').not(this).removeClass('active').children('.sub-menu').removeClass('active');
            
            // Toggle the current dropdown
            $(this).toggleClass('active');
            $(this).children('.sub-menu').toggleClass('active');
        });
        
        // Prevent closing when clicking inside the submenu
        $('.sub-menu--hidden > .sub-menu').on('click', function(e) {
            e.stopPropagation();
        });
        
        // Mobile menu toggle button
        $('#menu_toggle').on('click', function() {
            if ($('#target_pop_contact').hasClass('show')) {
                $('#target_pop_contact').fadeOut(300).removeClass('show');
            } else {
                nav.toggleClass('aside_open');
                $(this).toggleClass('active');
                $('#menu_target').fadeToggle(400);
                
                if ($(this).hasClass('active')) {
                    // Close all submenus when opening the main menu
                    $('.sub-menu--hidden').children('.sub-menu').removeClass('active');
                    $('.sub-menu--hidden').removeClass('active');
                }
            }
        });
    }

}

/* I M A G E S */
document.addEventListener("DOMContentLoaded", function() {
    var images = document.querySelectorAll("img");
    images.forEach(function(img) {
        img.setAttribute("loading", "lazy");
    });
});



document.addEventListener("DOMContentLoaded", function() {
    var containers = document.querySelectorAll(".media-container");

    // Array de colores predefinidos
    var colors = ['#F0ED9C', '#BDD6C6', '#F97743', '#F7C6C8', '#DECFA6'];

    containers.forEach(function(container) {
        // Selecciona un índice aleatorio del array
        var randomIndex = Math.floor(Math.random() * colors.length);
        
        // Utiliza el índice para obtener el color correspondiente
        var randomColor = colors[randomIndex];
        
        // Establece el color de fondo en el contenedor
        container.style.backgroundColor = randomColor;
        
        // Agrega la clase 'loaded' cuando la imagen ha cargado
        container.querySelector("img").addEventListener("load", function() {
            container.classList.remove("loading");
            container.classList.add("loaded");
        });

        // Si la imagen ya está en caché y se carga antes de que se adjunten los manejadores de eventos, agregamos la clase 'loaded' manualmente
        if (container.querySelector("img").complete) {
            container.classList.add("loaded");
        }
    });

    /* T A B S */
    $('#tabs_control').on('click', function(){
        $(this).toggleClass('open');
        $(this).siblings('.book__tabs-header-select-options').fadeToggle(300);
    });
    $('input[name="service"]').on( 'change', function(){
       
        $('#tabs_control').children('.current_text').html($(this).data('text') + '<span class="arrow-select arrow-select--mobile"></span>');
        $('#tabs_control').toggleClass('open');
        $('#tabs_control').siblings('.book__tabs-header-select-options').fadeToggle(300);
        let target = $(this).val();
        let before = $('#tabs_container').find('div[data-service].active');
        $(before).removeClass('active');
        let target_container = $('#tabs_container').find(`div[data-service="${target}"]`);
        $(target_container).addClass('active');
	});
    /* END T A B S */
});

 /* W I D G E T in P O P U P */
 $('.btn_pop_widget').on('click', function(){
    console.log('Launch Widget')
    let post = $(this).data('post');
    let key = $(this).data('key');
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: { action: 'widget', post: post, key : key},
        success: function(data){
            $('#pop_up_wrapper').html( data );
            $('#pop_up_widget_close').on('click', function(){
                $('#pop_up_widget').fadeOut(200);
                $('#pop_character_wrapper').html('');
            });
        },
        error: function(errors){
            console.log( errors );
        }
    });
 });
 $('.btn_pop_class').on('click', function(){
    console.log('Launch Widget')
    let post = $(this).data('post');
    let key = $(this).data('key');
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: { action: 'class', post: post, key : key},
        success: function(data){
            $('#pop_up_wrapper').html( data );
            $('#pop_up_widget_close').on('click', function(){
                $('#pop_up_widget').fadeOut(200);
                $('#pop_character_wrapper').html('');
            });
        },
        error: function(errors){
            console.log( errors );
        }
    });
 });
 $('.btn_pop_blog').on('click', function(){
    $(this).parent().siblings('.pop_up_wrapper_blog').fadeIn(300);
 })
 $('.pop_up_widget_close').on('click', function(){
    $(this).parent().parent().parent().parent().parent().parent('.pop_up_wrapper_blog').fadeOut(200);
});
/* END W I D G E T in P O P U P */

/* S L I D E R  S I N G L E */
ScrollTrigger.matchMedia({
    // Tablets & mobile
    "(max-width: 951px)": function() {
        if( $('#gallery_single_mobile').length ){
            console.log('Single Gallery')
            $('#gallery_single_mobile').slick({
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                prevArrow: "<div class='arrow-slick arrow-slick--left'>",
                nextArrow: "<div class='arrow-slick arrow-slick--right'>",
                lazyLoad: 'ondemand'
            })
        }
    }
});
/* END S L I D E R  S I N G L E */

/* L O A D  M O R E */
let pager = 1;
let request = true;

$('.load_more_articles').on('click', function(){
    let offset = $(this).data('offset');
    call_articles( offset, $(this) );
});
const call_articles = ( offset = null, element = null ) => {
  if (request) {
    request = false;
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: cltvo_js_vars.ajax_url,
      data: { 
          action : 'load_more', 
          offset: offset
      },
      success: function(data){
        pager+=1;
        offset+=6;
        $('#archive_wrapper').append( data );
        onAjaxDone(data);
        $(element).data('current-page', pager);
        $(element).attr('data-current-page', pager);
        $(element).data('offset', offset);
        $(element).attr('offset', offset);
        $('.load_more_articles').on('click', function(){
            let offset = $(this).data('offset');
            call_articles( offset, $(this) );
        });
      },
      error: function(errors){
        console.log( errors );
      }
    });
  }
}
let onAjaxDone = function() {
  if ($('#max_pages').val() == pager ) {
    let buttons = document.querySelectorAll('.archive-template__more');
    Array.from(buttons).forEach( btn => {
      $(btn).removeClass('show');
    })
    request = false;
  }else{
    let buttons = document.querySelectorAll('.archive-template__more');
    Array.from(buttons).forEach( btn => {
        $(btn).addClass('show');
    })
    request = true;
  }

}
/* END L O A D  M O R E */